export default "{\n    \"label\": \"Método de pago\",\n    \"placeholder\": \"Seleccione método de pago\"\n}"